import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Navbar.css';

function Header() {
  return (
    <Navbar expand="lg" className="">
      <Container>
        <Navbar.Brand href="#home">Samurai Dogg</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto">
            <Nav.Link href="#about">About</Nav.Link>
            <Nav.Link href="#tokenomics">Tokenomics</Nav.Link>
            <Nav.Link href="#howToBuy">How to Buy</Nav.Link>
            <Nav.Link href="#followUs">Follow Us</Nav.Link>
          </Nav>
            <Nav.Link className='connect_btn' rel="noreferrer" target='_blank' href='https://www.mexc.com/en-GB/dex/trade?pair_ca=HWpJ9swetiCSWua5E5hKscdFL84NQ7DRKmSEgFDF7kDW&chain_id=100000&token_ca=FaKa2PCL3UgYpkYz7LAoab5AKrifGGfMZtumMCChpump&base_token_ca=So11111111111111111111111111111111111111112'>Buy Now</Nav.Link>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}


export default Header;